import { defineStore } from 'pinia'
import axios from 'axios'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    originalRole: null,
    currentRole: null,
    isImpersonating: false
  }),

  actions: {
    startImpersonation(targetRole = 'client') {
      this.originalRole = this.currentRole
      this.currentRole = targetRole
      this.isImpersonating = true
      // Store original token but use a temporary one for client views
      localStorage.setItem('originalToken', localStorage.getItem('token'))
      // You could either:
      // 1. Get a temporary token from backend with reduced permissions
      // 2. Use the same token but add an impersonation header
      axios.defaults.headers.common['X-Impersonating-Role'] = targetRole
    },

    stopImpersonation() {
      this.currentRole = this.originalRole
      this.isImpersonating = false
      this.originalRole = null
      // Restore original token
      const originalToken = localStorage.getItem('originalToken')
      if (originalToken) {
        localStorage.setItem('token', originalToken)
        localStorage.removeItem('originalToken')
      }
      delete axios.defaults.headers.common['X-Impersonating-Role']
    }
  }
}) 